import { Caret } from "./Caret";

export class TextEditorEvent
{
  changeStart:Caret;
  changeEnd:Caret;
}